export const USER_SLICE_NAME = "user"
